import { render, staticRenderFns } from "./ChildrenAccounts.vue?vue&type=template&id=0faf0df7&scoped=true"
import script from "./ChildrenAccounts.vue?vue&type=script&lang=js"
export * from "./ChildrenAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf0df7",
  null
  
)

export default component.exports